// extracted by mini-css-extract-plugin
export var actionButton = "_7x-1";
export var actionButtons = "_7x-2";
export var actions = "_7x-0";
export var aiUnread = "_7x-10";
export var alignCenter = "_7x-h";
export var backWrapper = "_7x-3";
export var cellContainer = "_7x-4";
export var checkboxContainer = "_7x-5";
export var contentContainer = "_7x-6";
export var contentHeader = "_7x-8";
export var conversationsTableWrapper = "_7x-s";
export var draftReplyBadgeContainer = "_7x-m";
export var dropdownItem = "_7x-b";
export var dropdownItemsContainer = "_7x-a";
export var dropdownTitle = "_7x-c";
export var errorIcon = "_7x-7";
export var filter = "_7x-d";
export var gray = "_7x-i";
export var headerActionButtons = "_7x-e";
export var headerCheckboxContainer = "_7x-f";
export var icon = "_7x-j";
export var menuContainer = "_7x-k";
export var noMoreTicketsIcon = "_7x-12";
export var noMoreTicketsSubText = "_7x-13";
export var oneLine = "_7x-l";
export var optionsButton = "_7x-n";
export var plus = "_7x-o";
export var portalButtonsWrapper = "_7x-g";
export var red = "_7x-p";
export var scrolledTop = "_7x-9";
export var search = "_7x-q";
export var selectedConversationsCount = "_7x-r";
export var spinner = "_7x-t";
export var strong = "_7x-u";
export var summaryCell = "_7x-v";
export var tableContainer = "_7x-11";
export var tagContainer = "_7x-w";
export var threeDots = "_7x-x";
export var twoLines = "_7x-y";
export var unread = "_7x-z";